/* Adds a WORK WITH US column (Bulk orders, Creators) to whichever Ice Freaks
   footer is on the page: the main store page footer or the shared one.
   Finds the footer by its HELP heading rather than by id, so it works on
   both without editing either template. */
(function(){
var LINKS=[['Bulk & B2B orders','/pages/b2b'],['Creators & partnerships','/pages/creators']];
function add(){
var spans=document.querySelectorAll('footer span');
for(var i=0;i<spans.length;i++){
if((spans[i].textContent||'').trim()!=='HELP')continue;
var col=spans[i].parentNode;
var row=col&&col.parentNode;
if(!row||row.querySelector('[data-if-partner]'))continue;
var c=col.cloneNode(false);
c.setAttribute('data-if-partner','1');
var h=spans[i].cloneNode(true);
h.textContent='WORK WITH US';
c.appendChild(h);
var sample=col.querySelector('a');
LINKS.forEach(function(l){
var a=document.createElement('a');
a.href=l[1];a.textContent=l[0];
if(sample)a.setAttribute('style',sample.getAttribute('style')||'');
c.appendChild(a);
});
row.appendChild(c);
}
}
var n=0;
var iv=setInterval(function(){n++;add();if(n>30)clearInterval(iv);},300);
if(document.readyState!=='loading')add();else document.addEventListener('DOMContentLoaded',add);
})();
